module.exports = require("./smn");